import { CREATE_COURSE, CREATE_MODULE, GET_COURSE, GET_MODULE, SET_ALL_COURSES, SET_ALL_MODULES, UPDATE_COURSE, UPDATE_MODULE } from "../../reducerTypes"

const initialState = {
  getData: {},
  getList: []
}

const moduleReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ALL_MODULES:
      return{
        ...state,
        getList: action.payload
      }
    case CREATE_MODULE:
      return{
        ...state,
        currentInstuctor: action.payload
      }
    case GET_MODULE:
    return{
      ...state,
      getData: action.payload
    }
    case UPDATE_MODULE: 
    return{
      ...state,
      currentInstuctor: action.payload
    }
    default:
      return state
  }
}

export default moduleReducer
